'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function checkShouldInheritVariant(_a) {
  var animate = _a.animate,
    variants = _a.variants,
    inherit = _a.inherit;
  return inherit !== null && inherit !== void 0 ? inherit : !!variants && !animate;
}

exports.checkShouldInheritVariant = checkShouldInheritVariant;
